export default __webpack_public_path__ + "static/media/halog-logo-text-dark-theme.e3f47cbe.png";